/** Product / conversation-target slugs → plain display names for annotator UI. */

const PRODUCT_DISPLAY_NAMES = {
  carestart: "CareStart",
  carestart3: "CareStart",
  chartmind: "ChartMind",
  decisionpoint: "DecisionPoint",
};

const TARGET_DISPLAY_NAMES = {
  "scmap4-voice": "CareStart voice",
  scmap4: "CareStart",
};

export function formatSessionProductLabel(productId) {
  if (!productId) return "—";
  const key = String(productId).toLowerCase();
  return PRODUCT_DISPLAY_NAMES[key] || productId;
}

export function formatSessionTargetLabel(conversationTarget) {
  if (!conversationTarget) return "—";
  const key = String(conversationTarget).toLowerCase();
  return TARGET_DISPLAY_NAMES[key] || conversationTarget;
}
